<template>
  <div class="news">
    <div class="new-title-container">
      <div class="blank"></div>
      <div class="news-title">
        {{ newCenter.title }}
      </div>
      <span class="all" @click="go('Newcenter')">{{ newCenter.slogan }}</span>
    </div>
    <div class="news-container">
      <div class="news-container-left">
        <el-image
          :src="newCenter.url"
          class="news-img"
          :alt="newCenter.title"
          @error.once="error"
        />
      </div>
      <ul class="news-container-right">
        <li
          v-for="(item, index) in topNews"
          :id="{ activeItem: index === currentIndex }"
          :key="'news' + index"
          class="news-container-right-li"
          :class="{ active: index === currentIndex }"
          @mouseover="changeStyle(index)"
          @click="go('newShow', item)"
        >
          <div class="news-items">
            <span class="news-item">{{ item.title.trim() }}</span>
            <span class="news-time">{{ item.createTimefomate }}</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { myMixin } from '../../mixin'
import HomeApi from '../../network/home'
import { program_type, content_type } from '../../common/enum/imgEnum'
import dateDiff from '../../utils/dateDiff'
import { mapMutations } from 'vuex'

export default {
  name: 'News',
  mixins: [myMixin],
  data() {
    return {
      newsList: [
        {
          time: '1634961840000',
          title: '祝贺华运昌成为福永物流协会理事单位',
          url: 'https://mp.weixin.qq.com/s?__biz=Mzg2MTQ1NTcwMQ==&mid=2247484843&idx=1&sn=66cf246d793ef889db42294e7770e6c4&chksm=ce179191f9601887b14baa036bc475d2c465dc7d58b3a0293538dbb9455fac72eae55fd24c95&token=58900985&lang=zh_CN#rd'
        },
        {
          time: '1634961840000',
          title: '【行业资讯】工厂限电对跨境电商有多大影响？',
          url: 'https://mp.weixin.qq.com/s?__biz=Mzg2MTQ1NTcwMQ==&mid=2247484843&idx=2&sn=3c4b8859a8542c953ee44d4f98b72268&chksm=ce179191f9601887a458f8836a43f61df72bfd4bbb6a587c13dda144c4da91969a6587a3e317&token=58900985&lang=zh_CN#rd'
        },
        {
          time: '1634356920000',
          title: '用技术革新服务II华运昌会员端系统正式上线！',
          url: 'https://mp.weixin.qq.com/s?__biz=Mzg2MTQ1NTcwMQ==&mid=2247484806&idx=1&sn=84d3897606a6ce91e5176f0480833227&chksm=ce1791bcf96018aa306a61e3bd8cdafad9c9578d0f08631e03f6b809bea1c4d22c04484469ff&token=58900985&lang=zh_CN#rd'
        },
        {
          time: '1633063200000',
          title: '自古时光留不住，唯有真诚得人心||感谢“物博会”上每一个相遇的你',
          url: 'https://mp.weixin.qq.com/s?__biz=Mzg2MTQ1NTcwMQ==&mid=2247484668&idx=1&sn=c6a21a7e12aa5fa5a0169e08079f30e7&chksm=ce1790c6f96019d0ee2267a14215d1f17024996213a39d08b8ed519466c18cbf51ba5d1ec885&token=58900985&lang=zh_CN#rd'
        },
        {
          time: '1631865840000',
          title: '生活不止眼前的工作，还有诗和远方的快乐',
          url: 'https://mp.weixin.qq.com/s?__biz=Mzg2MTQ1NTcwMQ==&mid=2247484542&idx=1&sn=19e25376ea12ba21e1c8c833326e5ad7&chksm=ce179044f96019525b322c6e0296d28286f2d1e69f64d857a779032527802e32317ebaf0ddfc&token=58900985&lang=zh_CN#rd'
        }
      ],
      newImage: require('@/assets/images/news/new.png'),
      currentIndex: -1,
      newCenter: {},
      topNews: []
    }
  },
  created() {
    this._getNewCenter()
    this._getTopNews()
  },
  methods: {
    // 重写跳转
    ...mapMutations(['setNew']),
    go(path, news) {
      this.setNew(news)
      this.$router.push({ name: path })
    },

    changeStyle(index) {
      this.currentIndex = index
    },

    async error() {
      await this._getNewCenter()
    },
    /**
     * 获取新闻中心
     */
    async _getNewCenter() {
      const result = await HomeApi.getContent(
        program_type.official_website,
        content_type.homeNewCenter
      )
      this.newCenter = result.data[0]
    },
    /**
     * 获取前五条新闻
     */
    async _getTopNews() {
      const result = await HomeApi.selectTopFiveNew()
      let arr = result.data.list
      arr = arr.sort((a, b) => b.createTime - a.createTime)
      arr.forEach((key) => {
        key.createTimefomate = dateDiff(key.createTime)
      })
      this.topNews = arr
    }
  }
}
</script>

<style scoped>
.news {
  padding: 50px;
}
.news-title {
  font-size: 36px;
  text-align: center;
  line-height: 40px;
  font-weight: 700;
  margin: auto;
  margin-bottom: 50px;
}

.new-title-container {
  display: flex;
  justify-content: space-around;
}

.all {
  color: #cccccc;
  cursor: pointer;
}

.blank {
  width: 56px;
  height: 90px;
}

.news-container {
  display: flex;
  height: 375px;
  justify-content: center;
  background: #f9f9f9;
}

.news-container-left {
  flex: 1;
}

.news-container-left .news-img {
  border-radius: 20px;
  overflow: hidden;
}

.news-container-right {
  display: flex;
  flex-direction: column;
  width: 45%;
}

.news-container-right-li {
  width: 100%;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  border-bottom: 1px solid #ddd;
  font-size: 12px;
  color: #000;
}

.news-container-right-li > .news-items {
  display: flex;
  justify-content: space-between;
  padding: 20px;
  background: 0 0;
  opacity: 0.85;
  line-height: 14px;
}

.active {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  transition: all 0.6s ease;
  transform: translate3d(0, 0, 0);
  font-size: 15px;
  color: #dddddd;
  border: none;
  padding: 30px 20px;
  background: linear-gradient(140deg, #1c3d70 0, #fe8548 100%);
  border-radius: 20px;
  width: 600px;
  transform: translateX(-60px);
}

.news-items > .news-item {
  max-width: 400px;
}

.news-item {
  width: 300px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
